var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Prop, Vue } from 'vue-property-decorator';
import { checkTermsOfWhatsappEnrichment } from '@/clients/enrichment_whatsapp';
import WhatsappEnrichmentIframeModal from './EnrichmentWhatsapp/WhatsappEnrichmentIframeModal.vue';
let WhatsappEnrichmentDropdown = class WhatsappEnrichmentDropdown extends Vue {
    constructor() {
        super(...arguments);
        this.openRequestModal = false;
        this.preparing = false;
        this.termsAccepted = false;
    }
    /**
     * Verifica os termos antes de abrir o modal.
     * O spinner no botão indica que a verificação está em curso.
     */
    async openSolicitar() {
        this.preparing = true;
        try {
            await this.loadTermsStatus();
        }
        catch (e) {
            console.error('[WhatsApp] Erro ao verificar termos:', e);
        }
        finally {
            this.preparing = false;
        }
        this.openRequestModal = true;
    }
    /** Verifica se o usuário já aceitou os termos de uso. */
    async loadTermsStatus() {
        try {
            const response = await checkTermsOfWhatsappEnrichment();
            this.termsAccepted = !!(response.data && response.data.accepted);
        }
        catch {
            this.termsAccepted = false;
        }
    }
};
__decorate([
    Prop({ default: false })
], WhatsappEnrichmentDropdown.prototype, "listLoading", void 0);
__decorate([
    Prop({ default: false })
], WhatsappEnrichmentDropdown.prototype, "noFoundInfoset", void 0);
WhatsappEnrichmentDropdown = __decorate([
    Component({
        name: 'WhatsappEnrichmentDropdown',
        components: { WhatsappEnrichmentIframeModal },
    })
], WhatsappEnrichmentDropdown);
export default WhatsappEnrichmentDropdown;
